import { version } from "@krystal/icons";
import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "@/common/directives/when";
import { EkoElement } from "@/utilities/element";
import style from "./icon.css?inline";

@customElement("eko-icon")
class Icon extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) color?: string;
  @property({ reflect: true }) label?: string;
  @property({ reflect: true }) name: string = "";
  @property({ reflect: true }) size: "full" | "sm" | "md" | "lg" | "xl" = "md";
  @property({ reflect: true }) theme?:
    | "danger"
    | "error"
    | "info"
    | "neutral"
    | "success"
    | "warning"
    | "weak"
    | "weaker"
    | "weakest";

  iconUrl(icon: string) {
    return `https://assets.ekosystem.krystal.io/icons/${version}/${icon}.svg`;
  }

  render() {
    return html`
      <div
        class="eko-icon"
        style=${when(this.color, `--_eko-icon-color: ${this.color}`)}
        part="root"
        role=${when(this.label, "img")}
        aria-label=${when(this.label)}
        aria-hidden=${when(!this.label, "true")}>
        <slot aria-hidden="true"></slot>
        <div class="eko-icon__svg" style="mask: url(${this.iconUrl(this.name)})" part="svg"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-icon": Icon;
  }
}

export default Icon;
